module.exports = __webpack_public_path__ + "static/media/logsBackArrow.e8572169.svg";